import _extends from '@babel/runtime/helpers/extends';
import React, { Children, isValidElement, cloneElement, forwardRef } from 'react';
import _jsx from '@babel/runtime/helpers/jsx';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import { ARROW_RIGHT, ARROW_LEFT, SPACE, ENTER } from '@andes/common/build/constants/keyboardCodes';
import { useId } from '@andes/context';
const namespace$2 = 'control-arrow';
const ArrowLeft = _ref => {
  let {
    disabled = false,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classNames(namespace$2, disabled && "".concat(namespace$2, "--disabled")),
    onClick: !disabled ? onClick : undefined,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, void 0, /*#__PURE__*/_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, void 0, /*#__PURE__*/_jsx("path", {
    fill: "#000",
    fillOpacity: disabled ? '.25' : '.9',
    fillRule: "nonzero",
    d: "M7.833 9.99l4.796-4.795-.849-.849-5.644 5.645 5.65 5.649.848-.849z"
  })));
};
var ArrowLeft$1 = ArrowLeft;
const namespace$1 = 'control-arrow';
const ArrowRight = _ref => {
  let {
    disabled = false,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classNames(namespace$1, disabled && "".concat(namespace$1, "--disabled")),
    onClick: !disabled ? onClick : undefined,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, void 0, /*#__PURE__*/_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, void 0, /*#__PURE__*/_jsx("path", {
    fill: "#000",
    fillOpacity: disabled ? '.25' : '.9',
    fillRule: "nonzero",
    d: "M7.428 5.195l.849-.849 5.644 5.645-5.65 5.649-.848-.849 4.801-4.8z"
  })));
};
var ArrowRight$1 = ArrowRight;
const namespace = 'andes-tabs';
const tabNamespace = 'andes-tab';
const tabContentNamespace = 'andes-tab-content';
const swipeableContentNamespace = "".concat(namespace, "__swipeable-content");
const swipeableContentScrollNamespace = "".concat(swipeableContentNamespace, "-scroll");
const SWIPE_ANIMATION_DURATION = 300;
const addEventListeners = $this => {
  if (typeof document === 'undefined') return;
  const swipeContainer = document.querySelector(".".concat(swipeableContentScrollNamespace));
  if (swipeContainer) {
    $this.swipeContainer = swipeContainer;
    $this.swipeContainer.addEventListener('touchstart', $this.handleSubcontainerTouchStart);
    $this.swipeContainer.addEventListener('touchmove', $this.handleSubcontainerTouchMove);
    $this.swipeContainer.addEventListener('touchend', $this.handleSubcontainerTouchEnd);
  }
};
const removeEventListeners = $this => {
  if ($this.swipeContainer) {
    $this.swipeContainer.removeEventListener('touchstart', $this.handleSubcontainerTouchStart);
    $this.swipeContainer.removeEventListener('touchmove', $this.handleSubcontainerTouchMove);
    $this.swipeContainer.removeEventListener('touchend', $this.handleSubcontainerTouchEnd);
  }
};
const getCurrentSelectedIndex = $this => {
  const {
    selected
  } = $this.state;
  return $this.enabledTabsIndexes.indexOf(selected);
};
const executeOnSelectIfExists = element => {
  var _element$props;
  if (typeof (element === null || element === void 0 || (_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.onSelect) === 'function') element.props.onSelect();
};
const resetSubcontainerStyles = $this => {
  requestAnimationFrame(() => {
    var _$this$swipeContainer;
    (_$this$swipeContainer = $this.swipeContainer) === null || _$this$swipeContainer === void 0 || _$this$swipeContainer.setAttribute('style', '');
  });
};
const goToPreviousTab = $this => {
  $this.avoidTouches = true;
  requestAnimationFrame(() => {
    var _$this$swipeContainer2;
    const translate = $this.initialTranslate + $this.containerWidth;
    (_$this$swipeContainer2 = $this.swipeContainer) === null || _$this$swipeContainer2 === void 0 || _$this$swipeContainer2.setAttribute('style', "transition-duration: ".concat(SWIPE_ANIMATION_DURATION, "ms; transform: translateX(calc(").concat(translate, "px - 1.5em))"));
  });
  const previousIndex = getCurrentSelectedIndex($this) - 1;
  const previousContent = $this.tabsContent[previousIndex];
  clearTimeout($this.swipeTimeout);
  $this.swipeTimeout = setTimeout(() => {
    $this.avoidTouches = false;
    $this.setSelectedTab($this.enabledTabsIndexes[previousIndex], () => {
      resetSubcontainerStyles($this);
      if (previousContent) executeOnSelectIfExists(previousContent);
    });
  }, SWIPE_ANIMATION_DURATION);
};
const goToNextTab = $this => {
  $this.avoidTouches = true;
  requestAnimationFrame(() => {
    var _$this$swipeContainer3;
    const translate = -$this.containerWidth + $this.initialTranslate;
    (_$this$swipeContainer3 = $this.swipeContainer) === null || _$this$swipeContainer3 === void 0 || _$this$swipeContainer3.setAttribute('style', "transition-duration: ".concat(SWIPE_ANIMATION_DURATION, "ms; transform: translateX(calc(").concat(translate, "px + 1.5em))"));
  });
  const nextIndex = getCurrentSelectedIndex($this) + 1;
  const nextContent = $this.tabsContent[nextIndex];
  clearTimeout($this.swipeTimeout);
  $this.swipeTimeout = setTimeout(() => {
    $this.avoidTouches = false;
    $this.setSelectedTab($this.enabledTabsIndexes[nextIndex], () => {
      resetSubcontainerStyles($this);
      if (nextContent) executeOnSelectIfExists(nextContent);
    });
  }, SWIPE_ANIMATION_DURATION);
};
const stayOnCurrentTab = $this => {
  $this.avoidTouches = true;
  requestAnimationFrame(() => {
    var _$this$swipeContainer4;
    (_$this$swipeContainer4 = $this.swipeContainer) === null || _$this$swipeContainer4 === void 0 || _$this$swipeContainer4.setAttribute('style', "transition-duration: ".concat(SWIPE_ANIMATION_DURATION, "ms; transform: translateX(").concat($this.initialTranslate, "px)"));
  });
  clearTimeout($this.swipeTimeout);
  $this.swipeTimeout = setTimeout(() => {
    $this.avoidTouches = false;
    resetSubcontainerStyles($this);
  }, SWIPE_ANIMATION_DURATION);
};
const getTouchAngle = ($this, newX, newY) => {
  const diffX = Math.abs(newX - $this.initialX);
  const diffY = Math.abs(newY - $this.initialY);
  return Math.atan2(diffY, diffX) * (180 / Math.PI);
};
const getInitialSubcontainerTranslate = $this => {
  const transformStyle = window.getComputedStyle($this.swipeContainer).transform;
  let transform = 0;
  if (typeof transformStyle === 'string' && transformStyle.includes('matrix')) {
    var _transformStyle$match;
    const matrixValues = (_transformStyle$match = transformStyle.match(/matrix.*\((.+)\)/)) === null || _transformStyle$match === void 0 ? void 0 : _transformStyle$match[1].split(', ');
    const x = matrixValues === null || matrixValues === void 0 ? void 0 : matrixValues[4];
    transform = Number(x);
  }
  return transform;
};
const handleSubcontainerTouchStart = (event, $this) => {
  var _$this$swipeContainer5;
  if ($this.avoidTouches) return;
  $this.initialX = event.touches[0].clientX;
  $this.initialY = event.touches[0].clientY;
  $this.initialTranslate = getInitialSubcontainerTranslate($this);
  $this.containerWidth = ((_$this$swipeContainer5 = $this.swipeContainer) === null || _$this$swipeContainer5 === void 0 || (_$this$swipeContainer5 = _$this$swipeContainer5.parentElement) === null || _$this$swipeContainer5 === void 0 ? void 0 : _$this$swipeContainer5.clientWidth) || 0;
  $this.totalTranslate = 0;
  $this.currentTouchTranslate = 0;
  $this.avoidTouches = false;
  $this.approvedTouchAngle = false;
  $this.touchAngleCalculated = false;
};
const handleSubcontainerTouchMove = (event, $this) => {
  if ($this.avoidTouches) return;
  const {
    clientX: currentClientX,
    clientY: currentClientY
  } = event.changedTouches[0];
  if (!$this.touchAngleCalculated) {
    const angle = getTouchAngle($this, currentClientX, currentClientY);
    $this.touchAngleCalculated = true;
    $this.approvedTouchAngle = Boolean(angle <= 45);
  }
  if ($this.approvedTouchAngle && event.cancelable) {
    event.preventDefault();
    $this.currentTouchTranslate = $this.initialX - currentClientX;
    $this.totalTranslate = $this.currentTouchTranslate - $this.initialTranslate;
    if (Math.abs($this.currentTouchTranslate) <= $this.containerWidth) {
      requestAnimationFrame(() => {
        var _$this$swipeContainer6;
        (_$this$swipeContainer6 = $this.swipeContainer) === null || _$this$swipeContainer6 === void 0 || _$this$swipeContainer6.setAttribute('style', "transform: translateX(".concat(-$this.totalTranslate, "px)"));
      });
    }
  }
};
const handleSubcontainerTouchEnd = $this => {
  if ($this.avoidTouches) return;
  const {
    selected
  } = $this.state;
  if (Math.abs($this.currentTouchTranslate) > $this.containerWidth / 2) {
    switch (true) {
      case selected === $this.enabledTabsIndexes[0]:
        {
          if ($this.currentTouchTranslate < 0) {
            stayOnCurrentTab($this);
          } else {
            goToNextTab($this);
          }
          break;
        }
      case selected === $this.enabledTabsIndexes[$this.enabledTabsIndexes.length - 1]:
        {
          if ($this.currentTouchTranslate < 0) {
            goToPreviousTab($this);
          } else {
            stayOnCurrentTab($this);
          }
          break;
        }
      default:
        if ($this.currentTouchTranslate < 0) {
          goToPreviousTab($this);
        } else {
          goToNextTab($this);
        }
    }
  } else {
    stayOnCurrentTab($this);
  }
};
const CENTERED = 'centered';
const LEFT_ALIGNED = 'leftAligned';
const FULL_WIDTH = 'fullWidth';
const computeBehavior = _ref => {
  let {
    behavior,
    centered,
    leftAligned,
    fullWidth
  } = _ref;
  if (behavior) return behavior;
  if (fullWidth) return FULL_WIDTH;
  if (centered) return CENTERED;
  if (leftAligned) return LEFT_ALIGNED;
  return undefined;
};
var computeBehavior$1 = computeBehavior;
const TABS_DISPLAY_NAME = 'Tabs';
const TAB_DISPLAY_NAME = 'Tab';
const TAB_CONTENT_DISPLAY_NAME = 'TabContent';
class Tabs extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSubcontainerTouchStart", event => handleSubcontainerTouchStart(event, this));
    _defineProperty(this, "handleSubcontainerTouchMove", event => handleSubcontainerTouchMove(event, this));
    _defineProperty(this, "handleSubcontainerTouchEnd", () => handleSubcontainerTouchEnd(this));
    this.tabsContent = [];
    this.approvedTouchAngle = false;
    this.avoidTouches = false;
    this.containerWidth = 0;
    this.currentTouchTranslate = 0;
    this.enabledTabsIndexes = [];
    this.initialTranslate = 0;
    this.initialX = 0;
    this.initialY = 0;
    this.swipeContainer = undefined;
    this.swipeTimeout = undefined;
    this.totalTranslate = 0;
    this.touchAngleCalculated = false;
    this.state = {
      selected: props.selected || props.selectedTab || props.defaultSelectedTab || 0,
      showScrollTool: false,
      wrapperScroll: 0
    };
    this.isControlled = props.selectedTab !== undefined;
    this.setSelectedTab = this.setSelectedTab.bind(this);
    this.moveScrollToSelectedTab = this.moveScrollToSelectedTab.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.tabRef = this.tabRef.bind(this);
    this.getScrollTool = this.getScrollTool.bind(this);
    this.scrollToNextTab = this.scrollToNextTab.bind(this);
    this.scrollToPreviousTab = this.scrollToPreviousTab.bind(this);
    this.onMoveFocusTab = this.onMoveFocusTab.bind(this);
    this.checkScrollToolDisplay = this.checkScrollToolDisplay.bind(this);
  }
  componentDidMount() {
    addEventListeners(this);
    window.addEventListener('resize', this.checkScrollToolDisplay);
    if (this.wrapper) {
      this.wrapper.addEventListener('scroll', this.onScroll);
    }
    this.checkScrollToolDisplay();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      selected,
      selectedTab
    } = this.props;
    if (nextProps.selected !== selected) {
      this.setSelectedTab(nextProps.selected);
    } else if (nextProps.selectedTab !== selectedTab) {
      this.setSelectedTab(nextProps.selectedTab);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      children,
      selected: selectedProp,
      selectedTab: selectedTabProp
    } = this.props;
    const {
      selected,
      showScrollTool
    } = this.state;
    const {
      selected: prevSelected,
      showScrollTool: prevShowScrollTool
    } = prevState;
    if (Children.count(children) !== Children.count(prevProps.children)) {
      this.setSelectedTab(selectedProp || selectedTabProp);
    }
    const selectedHasChanged = prevSelected !== selected && selected !== undefined && selected !== null;
    const showScrollToolHasChanged = prevShowScrollTool !== showScrollTool;
    if (selectedHasChanged || showScrollToolHasChanged) {
      if (this.selectedTab && !this.isElementInScrollViewport(this.selectedTab)) this.moveScrollToSelectedTab();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.checkScrollToolDisplay);
    if (this.wrapper) {
      this.wrapper.removeEventListener('scroll', this.onScroll);
    }
    removeEventListeners(this);
  }
  onTabClick(event, tabIndex, tabId) {
    const {
      onChange
    } = this.props;
    if (!this.isControlled) this.setSelectedTab(tabIndex);
    if (typeof onChange === 'function') {
      const el = event.target;
      el.value = tabIndex;
      el.id = tabId;
      onChange(event);
    }
  }
  checkScrollToolDisplay() {
    const showScrollTool = this.wrapper && this.wrapper.scrollWidth > this.wrapper.clientWidth || false;
    this.setState({
      showScrollTool
    });
  }
  onScroll(event) {
    const scrollableElement = event.target;
    if (scrollableElement && scrollableElement !== null && scrollableElement !== void 0 && scrollableElement.scrollLeft) {
      const {
        scrollLeft
      } = scrollableElement;
      this.setState({
        wrapperScroll: scrollLeft
      });
    }
  }
  getTabs(behavior) {
    const {
      id,
      children
    } = this.props;
    const {
      selected
    } = this.state;
    return Children.map(children, (child, index) => {
      var _child$props, _child$props2, _child$props3, _child$props4, _child$props5, _child$props6, _tabContent$props;
      const tabId = (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id) || "".concat(id, "-tab-").concat(index);
      const tabContent = child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.children;
      this.tabsContent[index] = /*#__PURE__*/isValidElement(tabContent) ? /*#__PURE__*/cloneElement(tabContent, {
        tabId,
        disabled: child === null || child === void 0 || (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.disabled,
        index,
        onSelect: child === null || child === void 0 || (_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : _child$props4.onClick,
        id: tabContent.props.id || "".concat(id, "-tab-content-").concat(index)
      }) : null;
      this.enabledTabsIndexes = Object.values(this.tabsContent).filter(content => {
        var _content$props;
        return !(content !== null && content !== void 0 && (_content$props = content.props) !== null && _content$props !== void 0 && _content$props.disabled);
      }).map(content => {
        var _content$props2;
        return content === null || content === void 0 || (_content$props2 = content.props) === null || _content$props2 === void 0 ? void 0 : _content$props2.index;
      });
      return /*#__PURE__*/isValidElement(child) && /*#__PURE__*/cloneElement(child, {
        id: tabId,
        title: child === null || child === void 0 || (_child$props5 = child.props) === null || _child$props5 === void 0 ? void 0 : _child$props5.title,
        className: classNames(child === null || child === void 0 || (_child$props6 = child.props) === null || _child$props6 === void 0 ? void 0 : _child$props6.className, {
          ["andes-tab--".concat(behavior)]: behavior
        }, {
          'andes-tab--first': index === 0,
          'andes-tab--last': index === Children.count(children) - 1
        }),
        onMoveFocusTab: this.onMoveFocusTab,
        onClick: event => {
          var _child$props7, _child$props8;
          if (!(child !== null && child !== void 0 && (_child$props7 = child.props) !== null && _child$props7 !== void 0 && _child$props7.href)) {
            this.onTabClick(event, index, tabId);
          }
          if (child !== null && child !== void 0 && (_child$props8 = child.props) !== null && _child$props8 !== void 0 && _child$props8.onClick) {
            child.props.onClick(event, index, tabId);
          }
        },
        tabIndex: index,
        tabRef: this.tabRef,
        selected: index === selected,
        tabContentId: this.tabsContent[index] ? (tabContent === null || tabContent === void 0 || (_tabContent$props = tabContent.props) === null || _tabContent$props === void 0 ? void 0 : _tabContent$props.id) || "".concat(id, "-tab-content-").concat(index) : undefined
      });
    });
  }
  onMoveFocusTab(event) {
    var _wrapper$firstElement;
    event.preventDefault();
    const {
      wrapper
    } = this;
    const tabs = wrapper === null || wrapper === void 0 || (_wrapper$firstElement = wrapper.firstElementChild) === null || _wrapper$firstElement === void 0 ? void 0 : _wrapper$firstElement.children;
    if (tabs) {
      const focusableTabs = [...tabs].filter(tab => tab && tab.getAttribute('aria-disabled') === 'false');
      const focusedElement = event.target;
      let focusIndex = focusableTabs.findIndex(tab => tab === focusedElement);
      if (event.code === ARROW_RIGHT) {
        focusIndex += 1;
        if (focusIndex >= focusableTabs.length) {
          focusIndex = 0;
        }
      } else if (event.code === ARROW_LEFT) {
        focusIndex -= 1;
        if (focusIndex < 0) {
          focusIndex = focusableTabs.length - 1;
        }
      }
      focusableTabs[focusIndex].focus();
    }
  }
  setSelectedTab(tabIndex, callback) {
    this.setState({
      selected: tabIndex
    }, callback);
  }
  getScrollTool() {
    const {
      state: {
        wrapperScroll
      },
      wrapper
    } = this;
    const leftArrowDisabled = wrapperScroll === 0;
    const rightArrowDisabled = wrapper ? wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 5 : true;
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__scroll-tool")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__scroll-tool--fade")
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__scroll-tool--controls")
    }, void 0, /*#__PURE__*/_jsx(ArrowLeft$1, {
      onClick: this.scrollToPreviousTab,
      disabled: leftArrowDisabled
    }), /*#__PURE__*/_jsx(ArrowRight$1, {
      onClick: this.scrollToNextTab,
      disabled: rightArrowDisabled
    })));
  }
  scrollToNextTab() {
    const {
      wrapper,
      getScrollDifference
    } = this;
    if (wrapper) wrapper.scrollLeft += getScrollDifference(wrapper);
  }
  scrollToPreviousTab() {
    const {
      wrapper,
      getScrollDifference
    } = this;
    if (wrapper) wrapper.scrollLeft -= getScrollDifference(wrapper);
  }
  getScrollDifference(wrapper) {
    const tabsScrollFadeWidth = 80;
    return wrapper.clientWidth - tabsScrollFadeWidth;
  }
  moveScrollToSelectedTab() {
    var _this$selectedTab;
    const newScroll = (_this$selectedTab = this.selectedTab) === null || _this$selectedTab === void 0 ? void 0 : _this$selectedTab.offsetLeft;
    if (this.wrapper && newScroll !== undefined) this.wrapper.scrollLeft = newScroll;
  }
  isElementInScrollViewport(el) {
    var _this$wrapper, _this$wrapper2;
    let threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;
    const wrapperWidth = ((_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.clientWidth) || 0;
    const wrapperScroll = ((_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.scrollLeft) || 0;
    const elementWidth = el.clientWidth;
    const elementOffset = el.offsetLeft;
    const x1 = wrapperScroll;
    const x2 = x1 + wrapperWidth;
    const t1 = elementOffset;
    const t2 = elementOffset + elementWidth;
    let visibleElementPixels;
    switch (true) {
      case t1 < x1 && t2 <= x1:
        {
          visibleElementPixels = 0;
          break;
        }
      case t1 <= x1 && t2 > x1:
        {
          visibleElementPixels = t2 - x1;
          break;
        }
      case t1 > x1 && t2 > x1 && t2 <= x2:
        {
          visibleElementPixels = t2 - t1;
          break;
        }
      case t1 <= x2 && t2 > x2:
        {
          visibleElementPixels = x2 - t1;
          break;
        }
      default:
        {
          visibleElementPixels = 0;
        }
    }
    if (visibleElementPixels && visibleElementPixels <= 0) return false;
    return visibleElementPixels && visibleElementPixels >= elementWidth * threshold;
  }
  getTabsContent() {
    var _firstEnabledContent$, _lastEnabledContent$p;
    const {
      swipeable = false
    } = this.props;
    const {
      selected
    } = this.state;
    if (!swipeable) return this.tabsContent[Number(selected)];
    const contentsArray = Object.values(this.tabsContent);
    const enabledTabsContent = contentsArray.filter(content => {
      var _content$props3;
      return !(content !== null && content !== void 0 && (_content$props3 = content.props) !== null && _content$props3 !== void 0 && _content$props3.disabled);
    });
    const firstEnabledContent = enabledTabsContent[0];
    const lastEnabledContent = enabledTabsContent[enabledTabsContent.length - 1];
    let disabledTabsBeforeCurrrentSelected = 0;
    for (let i = 0; i < contentsArray.length; i += 1) {
      var _contentsArray$i;
      if ((_contentsArray$i = contentsArray[i]) !== null && _contentsArray$i !== void 0 && (_contentsArray$i = _contentsArray$i.props) !== null && _contentsArray$i !== void 0 && _contentsArray$i.disabled) {
        disabledTabsBeforeCurrrentSelected += 1;
      }
      if (i === selected) break;
    }
    const enabledSelectedIndex = Number(selected) - disabledTabsBeforeCurrrentSelected;
    const isInitialTabContent = selected === (firstEnabledContent === null || firstEnabledContent === void 0 || (_firstEnabledContent$ = firstEnabledContent.props) === null || _firstEnabledContent$ === void 0 ? void 0 : _firstEnabledContent$.index);
    const isFinalTabContent = selected === (lastEnabledContent === null || lastEnabledContent === void 0 || (_lastEnabledContent$p = lastEnabledContent.props) === null || _lastEnabledContent$p === void 0 ? void 0 : _lastEnabledContent$p.index);
    const isMiddleTabContent = !isInitialTabContent && !isFinalTabContent;
    const initialTranslateNeeded = isFinalTabContent || isMiddleTabContent;
    const swipeableContentScrollClassnames = classNames(swipeableContentScrollNamespace, {
      ["".concat(swipeableContentScrollNamespace, "--translated")]: initialTranslateNeeded
    });
    const previousElement = enabledTabsContent[enabledSelectedIndex - 1];
    const currentElement = enabledTabsContent[enabledSelectedIndex];
    const nextElement = enabledTabsContent[enabledSelectedIndex + 1];
    return /*#__PURE__*/_jsx("div", {
      className: swipeableContentNamespace
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: swipeableContentScrollClassnames
    }, void 0, previousElement && /*#__PURE__*/cloneElement(previousElement, {
      srHidden: true
    }), currentElement, nextElement && /*#__PURE__*/cloneElement(nextElement, {
      srHidden: true
    })));
  }
  tabRef(tab, _, selected) {
    if (tab && selected) {
      this.selectedTab = tab;
    }
  }
  render() {
    const {
      'aria-label': ariaLabel,
      behavior: behaviorProp,
      centered,
      className,
      fullWidth,
      innerRef,
      leftAligned,
      srLabel
    } = this.props;
    const {
      showScrollTool
    } = this.state;
    const behavior = computeBehavior$1({
      behavior: behaviorProp,
      centered,
      leftAligned,
      fullWidth
    });
    const tabsClasses = classNames(namespace, className, {
      ["".concat(namespace, "--").concat(behavior)]: behavior
    });
    const containerClasses = classNames("".concat(namespace, "__container"), {
      ["".concat(namespace, "__container--").concat(behavior)]: behavior
    });
    const wrapperClasses = classNames("".concat(namespace, "__wrapper"), {
      ["".concat(namespace, "__wrapper--scrollable")]: showScrollTool
    });
    return /*#__PURE__*/React.createElement("div", {
      className: containerClasses,
      ref: innerRef
    }, /*#__PURE__*/React.createElement("div", {
      className: wrapperClasses,
      ref: wrapper => {
        this.wrapper = wrapper;
      }
    }, /*#__PURE__*/_jsx("div", {
      className: tabsClasses,
      role: "tablist",
      "aria-label": srLabel || ariaLabel
    }, void 0, this.getTabs(behavior))), showScrollTool && this.getScrollTool(), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__border")
    }), this.getTabsContent());
  }
}
Tabs.displayName = TABS_DISPLAY_NAME;
var Tabs$1 = Tabs;
const TabsContainer = /*#__PURE__*/function () {
  const TabsContainer = /*#__PURE__*/forwardRef((props, ref) => {
    const componentId = useId(props.id);
    return /*#__PURE__*/React.createElement(Tabs$1, _extends({}, props, {
      innerRef: ref,
      id: componentId
    }));
  });
  TabsContainer.displayName = 'TabsContainer';
  return TabsContainer;
}();
var TabsContainer$1 = TabsContainer;
const Tab = /*#__PURE__*/function () {
  const Tab = _ref => {
    let {
      className,
      disabled = false,
      href,
      id,
      onClick,
      onMoveFocusTab,
      selected = false,
      tabContentId,
      tabIndex,
      tabRef,
      title
    } = _ref;
    const handleClick = event => {
      if (!href) event.preventDefault();
      if (!selected && !disabled && typeof onClick === 'function') onClick(event);
    };
    const handleKeyDown = event => {
      switch (event.code) {
        case ENTER:
        case SPACE:
          handleClick(event);
          break;
        case ARROW_LEFT:
        case ARROW_RIGHT:
          if (typeof onMoveFocusTab === 'function') onMoveFocusTab(event, tabIndex);
          break;
      }
    };
    const handleRef = tab => {
      if (typeof tabRef === 'function') tabRef(tab, tabIndex, selected);
    };
    const tabClassNames = classNames(tabNamespace, className, {
      ["".concat(tabNamespace, "--selected")]: selected,
      ["".concat(tabNamespace, "--disabled")]: disabled
    });
    const Component = href && !disabled ? 'a' : 'button';
    return /*#__PURE__*/React.createElement(Component, {
      "aria-controls": tabContentId,
      "aria-disabled": disabled,
      "aria-selected": selected,
      className: tabClassNames,
      disabled: disabled,
      href: disabled ? undefined : href || '#',
      id: id,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      ref: handleRef,
      role: "tab",
      tabIndex: selected && !disabled ? 0 : -1,
      type: href || disabled ? 'button' : undefined
    }, /*#__PURE__*/_jsx("div", {
      className: "".concat(tabNamespace, "__link")
    }, void 0, typeof title === 'string' ? /*#__PURE__*/_jsx("span", {}, void 0, title) : title));
  };
  Tab.displayName = TAB_DISPLAY_NAME;
  return Tab;
}();
var Tab$1 = Tab;
const TabContent = _ref => {
  let {
    'aria-hidden': ariaHidden,
    children,
    className,
    id,
    srHidden,
    tabId
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "aria-hidden": srHidden || ariaHidden,
    "aria-labelledby": tabId,
    className: classNames(tabContentNamespace, className),
    id: id,
    role: "tabpanel",
    tabIndex: 0
  }, void 0, children);
};
TabContent.displayName = TAB_CONTENT_DISPLAY_NAME;
var TabContent$1 = TabContent;
export { Tab$1 as Tab, TabContent$1 as TabContent, TabsContainer$1 as Tabs };
